/**
 * @file nav-tab.tsx
 * @deprecated Copied to app/modules/procurement/pages/vendors_management/kyc-verification/nav-tab.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/vendors_management/kyc-verification/nav-tab
 * @description Page component for managing navigation tabs in the KYC verification section.
 *   Displays a list of navigation tabs with pagination, search functionality, and CRUD operations.
 *   Allows users to view the details of navigation tabs with warehouse context integration.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 *
 * @todo Permission guard commented out: enable hasModulePermission(KycVerifications) before
 *   production (same pattern as pending-certificates.tsx).
 */

import { MouseEvent, useEffect, useState } from "react";
import { toast } from "react-toastify";
import Search from "../../../../../_admin/assets/media/svg_uTrade/search.svg";
import APICallService from "../../../../../api/apiCallService";
import { seller } from "../../../../../api/apiEndPoints";
import { sellerJSON } from "../../../../../api/apiJSON/seller";
import {
  Accepted,
  InfoRequired,
  KycVerifications,
  NewRequests,
  PAGE_LIMIT,
  Rejected,
  UnderReview,
} from "../../../../../utils/constants";
import { sellerToast } from "../../../../../utils/toast";
import Accepteed from "./accepted";
import InformationRequired from "./information-required";
import NewRequest from "./new-request";
import Rejecteed from "./rejected";
import Review from "./review";
import {
  getKey,
  removeAllKeys,
  removeKey,
  setKey,
} from "../../../../../Global/history";
import {
  listKycVerification,
  listVendorAdvertisement,
  listVendorGoodsRequest,
  listVendorHistoryOfInventory,
  listVendorInventory,
  listVendorProfileCatalogue,
  listVendorStockDetails,
  VendorProfile,
} from "../../../../../utils/storeString";
import { ElementAnimateUtil } from "../../../../../_admin/assets/ts/_utils";
// import Method from "../../../../utils/methods";
import { useAuth } from "../../../auth";
import { useDebounce } from "../../../../../utils/useDebounce";
const KycVerification = () => {
  const { currentUser } = useAuth();
  const [sortClass, setSortClass] = useState({
    name: 1,
    position: 1,
  });
  const [edit, setEdit] = useState(false);
  const [message, setMessage] = useState("");
  const [fetchLoader, setFetchLoader] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);

  const [pageLimit, setPageLimit] = useState<any>(
    getKey(listKycVerification.limit) || PAGE_LIMIT
  );
  const [page, setPage] = useState<any>(getKey(listKycVerification.page) || 1);
  const [sellerData, setSellerData] = useState<any>();
  const [sortKey, setSortkey] = useState<any>();
  const [sortOrder, setSortOrder] = useState<any>();
  const [search, setSearch] = useState(
    getKey(listKycVerification.search)?.toString() || ""
  );
  const [totalRecords, setTotalRecords] = useState(0);
  const [tab, setTab] = useState([
    {
      name: "New request",
      content: <NewRequest sellerData={undefined} fetchLoader={fetchLoader} />,
      value: NewRequests,
    },
    {
      name: "Under review",
      content: <Review sellerData={undefined} fetchLoader={fetchLoader} />,
      value: UnderReview,
    },
    {
      name: "Information required",
      content: (
        <InformationRequired sellerData={undefined} fetchLoader={fetchLoader} />
      ),
      value: InfoRequired,
    },
    {
      name: "Accepted",
      content: <Accepteed sellerData={undefined} fetchLoader={fetchLoader} />,
      value: Accepted,
    },
    {
      name: "Rejected",
      content: <Rejecteed sellerData={undefined} fetchLoader={fetchLoader} />,
      value: Rejected,
    },
  ]);
  const [statusLoading, setStatusLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState<any>(() => {
    let tabValue = {
      name: "New request",
      content: <NewRequest sellerData={undefined} fetchLoader={true} />,
      value: NewRequests,
    };
    if (getKey(listKycVerification.currentTab)) {
      let tab: any = getKey(listKycVerification.currentTab);
      switch (parseInt(tab)) {
        case NewRequests:
          tabValue = {
            name: "New request",
            content: (
              <NewRequest sellerData={undefined} fetchLoader={fetchLoader} />
            ),
            value: NewRequests,
          };
          break;
        case UnderReview:
          tabValue = {
            name: "Under review",
            content: (
              <Review sellerData={undefined} fetchLoader={fetchLoader} />
            ),
            value: UnderReview,
          };
          break;
        case InfoRequired:
          tabValue = {
            name: "Information required",
            content: (
              <InformationRequired
                sellerData={undefined}
                fetchLoader={fetchLoader}
              />
            ),
            value: InfoRequired,
          };
          break;
        case Accepted:
          tabValue = {
            name: "Accepted",
            content: (
              <Accepteed sellerData={undefined} fetchLoader={fetchLoader} />
            ),
            value: Accepted,
          };
          break;
        case Rejected:
          tabValue = {
            name: "Rejected",
            content: (
              <Rejecteed sellerData={undefined} fetchLoader={fetchLoader} />
            ),
            value: Rejected,
          };
          break;
        default:
        // Set a default value here if needed
      }
    }
    return tabValue; // Return the value to initialize the state
  });
  const [previousTab, setPreviousTab] = useState<any>({
    name: "New request",
    content: <NewRequest sellerData={undefined} fetchLoader={true} />,
    value: NewRequests,
  });
  useEffect(() => {
    (async () => {
      await fetchKycVerification(
        page,
        pageLimit,
        currentTab.value,
        search,
        sortKey,
        sortOrder
      );
    })();
  }, [edit]);
  useEffect(() => {
    (async () => {
      await fetchKycVerification(
        page,
        pageLimit,
        currentTab.value,
        search,
        sortKey,
        sortOrder
      );
    })();
  }, [statusLoading]);
  useEffect(() => {
    let tabTemp = [...tab];
    if (previousTab) {
      if (previousTab.value !== currentTab.value) {
        var itemIndex = tabTemp.findIndex((x) => x.value == previousTab.value);
        switch (previousTab.value) {
          case NewRequests:
            tabTemp[itemIndex] = {
              ...tabTemp[itemIndex],
              name: "New request",
            };
            break;
          case UnderReview:
            tabTemp[itemIndex] = {
              ...tabTemp[itemIndex],
              name: "Under review",
            };
            break;
          case InfoRequired:
            tabTemp[itemIndex] = {
              ...tabTemp[itemIndex],
              name: "Information required",
            };
            break;
          case Accepted:
            tabTemp[itemIndex] = {
              ...tabTemp[itemIndex],
              name: "Accepted",
            };
            break;
          case Rejected:
            tabTemp[itemIndex] = {
              ...tabTemp[itemIndex],
              name: "Rejected",
            };
            break;
          default:
        }
      }
    }
    setTab(tabTemp);
  }, [currentTab]);
  useEffect(() => {
    (async () => {
      localStorage.removeItem("profile");
      // if (!Method.hasModulePermission(KycVerifications, currentUser)) {
      //   return window.history.back();
      // }
      if (
        getKey(listKycVerification.page) ||
        getKey(listKycVerification.limit)
      ) {
        if (getKey(listKycVerification.currentTab)) {
          let tab: any = getKey(listKycVerification.currentTab);
          await fetchKycVerification(
            page,
            pageLimit,
            parseInt(tab),
            search,
            sortKey,
            sortOrder
          );
        } else {
          await fetchKycVerification(
            page,
            pageLimit,
            currentTab.value,
            search,
            sortKey,
            sortOrder
          );
        }
      } else {
        await fetchKycVerification(
          page,
          pageLimit,
          currentTab.value,
          search,
          sortKey,
          sortOrder
        );
      }
      setDataFetched(true);
    })();
  }, []);

  useEffect(() => {
    if (dataFetched) {
      let initialScrollPosition: any = getKey(
        listKycVerification.scrollPosition
      );
      if (initialScrollPosition) {
        ElementAnimateUtil.scrollTo(parseInt(initialScrollPosition));
        setDataFetched(false);
        setKey(listKycVerification.search, "", false);
      }
      removeKey(VendorProfile.currentTab);
      removeAllKeys(listVendorProfileCatalogue);
      removeAllKeys(listVendorGoodsRequest);
      removeAllKeys(listVendorAdvertisement);
      removeAllKeys(listVendorInventory);
      removeAllKeys(listVendorHistoryOfInventory);
      removeKey(listVendorStockDetails.search);
    }
  }, [dataFetched]);

  const fetchKycVerification = async (
    pageNo: number,
    limit: number,
    listType: number,
    searchTerm?: string,
    sortKey?: string,
    sortOrder?: number
  ) => {
    setFetchLoader(true);
    let params: any = {
      pageNo: pageNo,
      limit: limit,
      sortKey: "name",
      sortOrder: 1,
      listType: listType,
      searchTerm: searchTerm ? searchTerm : "",
    };
    let apiService = new APICallService(
      seller.kycDetails,
      sellerJSON.listSellerKyc(params),
      "",
      "",
      "",
      "",
      KycVerifications
    );
    // let response = await apiService.callAPI();
    let response = {
      total: 1,
      records: [
        {
          KYC: {
            profileUpdatedAt: "2024-09-19T12:40:06.344Z",
            status: 1,
            statusMessage: "",
            statusUpdatedAt: "2024-09-19T12:40:06.344Z",
          },
          _id: "66ec1b513399a9b577403bed",
          ownerName: "Faiz Arab",
          name: "iTrust Finance",
          deactivated: true,
          _createdAt: "2024-09-19T12:38:41.852Z",
          _updatedAt: "2024-09-19T12:40:06.344Z",
          image:
            "http://u-trade-dev.s3.af-south-1.amazonaws.com/business/logo/1726749606527_3951599641848434.jpg",
        },
      ],
    };
    setTotalRecords(response.total);
    setNavTab(
      listType,
      response.records,
      response.total,
      pageNo,
      limit,
      searchTerm
    );
    setSellerData(response.records);
    setFetchLoader(false);
  };
  const setNavTab = (
    value: any,
    data: any,
    total: any,
    pageNo: any,
    limit: any,
    search: any
  ) => {
    let tabTemp = [...tab];
    let currentTab = {};
    switch (value) {
      case NewRequests:
        currentTab = {
          name: "New request (" + total + ")",
          content: (
            <NewRequest
              sellerData={data}
              fetchLoader={false}
              search={search}
              total={total}
              currentPage={pageNo}
              handleCurrentPage={handleCurrentPage}
              handleNextPage={handleNextPage}
              handlePreviousPage={handlePreviousPage}
              pageLimit={limit}
              handlePageLimit={handlePageLimit}
              // onSorting={onSorting}
            />
          ),
          value: value,
        };
        var itemIndex = tabTemp.findIndex((x) => x.value == value);
        tabTemp[itemIndex] = {
          ...tabTemp[itemIndex],
          name: "New request (" + total + ")",
        };
        break;
      case UnderReview:
        currentTab = {
          name: "Under review (" + total + ")",
          content: (
            <Review
              sellerData={data}
              fetchLoader={false}
              search={search}
              total={total}
              currentPage={pageNo}
              handleCurrentPage={handleCurrentPage}
              handleNextPage={handleNextPage}
              handlePreviousPage={handlePreviousPage}
              pageLimit={limit}
              handlePageLimit={handlePageLimit}
              // onSorting={onSorting}
            />
          ),
          value: UnderReview,
        };
        var itemIndex = tabTemp.findIndex((x) => x.value == value);
        tabTemp[itemIndex] = {
          ...tabTemp[itemIndex],
          name: "Under review (" + total + ")",
        };
        break;
      case InfoRequired:
        currentTab = {
          name: "Information required (" + total + ")",
          content: (
            <InformationRequired
              sellerData={data}
              fetchLoader={false}
              search={search}
              total={total}
              currentPage={pageNo}
              handleCurrentPage={handleCurrentPage}
              handleNextPage={handleNextPage}
              handlePreviousPage={handlePreviousPage}
              pageLimit={limit}
              handlePageLimit={handlePageLimit}
              handleEdit={handleEdit}
              edit={edit}
              saveChanges={saveChanges}
              onMessageChange={onMessageChange}
              statusLoading={statusLoading}
              handleClose={() => {
                setEdit(false);
              }}
              // onSorting={onSorting}
            />
          ),
          value: InfoRequired,
        };
        var itemIndex = tabTemp.findIndex((x) => x.value == value);
        tabTemp[itemIndex] = {
          ...tabTemp[itemIndex],
          name: "Information required (" + total + ")",
        };
        break;
      case Accepted:
        currentTab = {
          name: "Accepted (" + total + ")",
          content: (
            <Accepteed
              sellerData={data}
              fetchLoader={false}
              search={search}
              total={total}
              currentPage={pageNo}
              handleCurrentPage={handleCurrentPage}
              handleNextPage={handleNextPage}
              handlePreviousPage={handlePreviousPage}
              pageLimit={limit}
              handlePageLimit={handlePageLimit}
              // onSorting={onSorting}
            />
          ),
          value: Accepted,
        };
        var itemIndex = tabTemp.findIndex((x) => x.value == value);
        tabTemp[itemIndex] = {
          ...tabTemp[itemIndex],
          name: "Accepted (" + total + ")",
        };
        break;
      case Rejected:
        currentTab = {
          name: "Rejected (" + total + ")",
          content: (
            <Rejecteed
              sellerData={data}
              fetchLoader={false}
              search={search}
              total={total}
              currentPage={pageNo}
              handleCurrentPage={handleCurrentPage}
              handleNextPage={handleNextPage}
              handlePreviousPage={handlePreviousPage}
              pageLimit={limit}
              handlePageLimit={handlePageLimit}
              // onSorting={onSorting}
            />
          ),
          value: Rejected,
        };
        var itemIndex = tabTemp.findIndex((x) => x.value == value);
        tabTemp[itemIndex] = {
          ...tabTemp[itemIndex],
          name: "Rejected (" + total + ")",
        };
        break;
      default:
    }
    setCurrentTab(currentTab);
    setTab(tabTemp);
  };
  const changeSortClass = (event: MouseEvent<HTMLTableCellElement>) => {
    let currentValue = (event.target as HTMLTableCellElement).abbr;
    let sort = sortClass;
    sort = {
      ...sort,
      [currentValue]: sort[currentValue as keyof typeof sort] === 1 ? -1 : 1,
    };
    setSortClass(sort);
  };
  const createTabs = () => {
    const localTab = tab;
    let current = currentTab;
    const allTabs = localTab.map((tab) => {
      return (
        <li className="nav-item">
          <a
            href={"/"}
            className={
              current.value === tab.value
                ? "nav-link active fs-16 fw-600  text-active-dark "
                : "nav-link fs-16 fw-600  text-hover-dark text-active-dark"
            }
            data-bs-toggle="tab"
            onClick={() => handleSelectTab(tab)}
          >
            {tab.name}
          </a>
        </li>
      );
    });
    return allTabs;
  };
  const handleSelectTab = async (tab: any) => {
    if (!fetchLoader) {
      setPage(1);
      setSellerData(undefined);
      setTotalRecords(0);
      setKey(listKycVerification.currentTab, tab.value);
      setKey(listKycVerification.page, 1);
      await setPreviousTab(JSON.parse(JSON.stringify(currentTab)));
      await setNavTab(tab.value, 0, 0, 1, pageLimit, search);
      await fetchKycVerification(1, pageLimit, tab.value, search);
    }
  };
  const handleCurrentPage = async (val: number, currentTabValue: number) => {
    setPage(val);
    setKey(listKycVerification.page, val);
    await fetchKycVerification(
      val,
      pageLimit,
      currentTabValue,
      search,
      sortKey,
      sortOrder
    );
  };
  const handleNextPage = async (val: number, currentTabValue: number) => {
    setPage(val + 1);
    setKey(listKycVerification.page, val + 1);
    await fetchKycVerification(
      val + 1,
      pageLimit,
      currentTabValue,
      search,
      sortKey,
      sortOrder
    );
  };
  const handlePreviousPage = async (val: number, currentTabValue: number) => {
    setPage(val - 1);
    setKey(listKycVerification.page, val - 1);
    await fetchKycVerification(
      val - 1,
      pageLimit,
      currentTabValue,
      search,
      sortKey,
      sortOrder
    );
  };
  const handlePageLimit = async (event: any, currentTabValue: number) => {
    setPage(1);
    setKey(listKycVerification.page, 1);
    await setPageLimit(parseInt(event.target.value));
    await fetchKycVerification(
      1,
      event.target.value,
      currentTabValue,
      search,
      sortKey,
      sortOrder
    );
  };

  const debounce = useDebounce(fetchKycVerification,500)
  const handleSearch = async (event: any, currentTabValue: number) => {
    setFetchLoader(true);
    const searchValue = event.target.value;
    setSearch(event.target.value);
    await debounce(
      1,
      pageLimit,
      currentTabValue,
      event.target.value,
      sortKey,
      sortOrder
    );
    setFetchLoader(false);
  };
  const handleEdit = () => {
    setEdit(true);
  };
  const onMessageChange = async (event: any, sellerVal: any, index: number) => {
    let sellerDataTemp: any = [...sellerData];
    sellerDataTemp[index].KYC.statusMessage = event.target.value;
    setSellerData(sellerDataTemp);
    await setNavTab(
      currentTab.value,
      sellerDataTemp,
      totalRecords,
      page,
      pageLimit,
      search
    );
  };
  const saveChanges = async (index: number) => {
    await setStatusLoading(true);
    let sellerDataTemp: any = [...sellerData];
    let apiService = new APICallService(
      seller.kycStatusUpdate,
      sellerJSON.kycStatusUpdate({
        status: InfoRequired - 1,
        message: sellerDataTemp[index].KYC.statusMessage,
      }),
      {
        id: sellerDataTemp[index]._id,
      },
      "",
      "",
      "",
      KycVerifications
    );
    let response = await apiService.callAPI();
    if (response) {
      toast.success(sellerToast.messageUpdate);
      setEdit(false);
    }
    await setStatusLoading(false);
  };
  return (
    <div className="px-9 mt-10">
      <div className="row g-5 g-xxl-8">
        <div className="col-xl-12">
          <h1 className="main-title">KYC verification</h1>
        </div>
        <div className="col-xl-12">
          <div className="card border border-custom-color">
            <div className="card-body pb-5">
              <div className="scroll-x">
                <div className="d-grid">
                  <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                    {createTabs()}
                  </ul>
                  {sellerData && sellerData.length ? (
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="d-flex align-items-center position-relative my-1"
                        data-select2-id="select2-data-160-o6e1"
                      >
                        <span className="svg-icon svg-icon-3 position-absolute ms-4">
                          <img src={Search} alt="" />
                        </span>
                        <input
                          type="text"
                          value={search}
                          className="form-control form-control-solid text-dark w-lg-375px ps-12 h-60px"
                          placeholder="Search by seller name, business name…"
                          onChange={(event: any) => {
                            handleSearch(event, currentTab.value);
                          }}
                        />
                      </div>
                    </div>
                  ) : search.length ? (
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="d-flex align-items-center position-relative my-1"
                        data-select2-id="select2-data-160-o6e1"
                      >
                        <span className="svg-icon svg-icon-3 position-absolute ms-4">
                          <img src={Search} alt="" />
                        </span>
                        <input
                          type="text"
                          value={search}
                          className="form-control form-control-solid text-dark w-lg-375px ps-12 h-60px"
                          placeholder="Search by seller name, business name…"
                          onChange={(event: any) => {
                            handleSearch(event, currentTab.value);
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="tab-pane fade show active">
                <>{currentTab.content}</>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default KycVerification;
